import { useTeam } from "@hooks";

import TeamUserSelect from "../dropdown/TeamUserSelect";

export function RecordingAsSelection({
  recordingAs,
  setRecordingAs,
  showLabel = false,
}) {
  const { currentTeam } = useTeam();

  const handleMemberSelectChange = (event, value) => {
    setRecordingAs(value);
  };

  return (
    <TeamUserSelect
      team={currentTeam}
      value={recordingAs}
      onChange={handleMemberSelectChange}
      showLabel={showLabel}
      label="Record As"
      placeholder="Select user"
      searchPlaceholder="Search team"
      width="w-56"
      dataTestId="record-as-dropdown"
      defaultToCurrentUser={true}
    />
  );
}
